module.exports = __webpack_public_path__ + "static/media/screen_about.c5c3d44f.png";